export const DESTINATION_ICON_BY_CODE = {
    fbpixel: "/assets/images/typeImages/facebook-icon.png",
    fbcapi: "/assets/images/typeImages/facebook-icon.png",
    fboffline: "/assets/images/typeImages/facebook-icon.png",
    fbca: "/assets/images/typeImages/facebook-icon.png",
    fbapp: "/assets/images/typeImages/facebook-icon.png",
    alpixel: "/assets/images/typeImages/alpixel.png",
    ttpixel: "/assets/images/typeImages/tiktok-icon.png",
    ttcapi: "/assets/images/typeImages/tiktok-icon.png",
    ttoffline: "/assets/images/typeImages/tiktok-icon.png",
    ttca: "/assets/images/typeImages/tiktok-icon.png",
    ttapp: "/assets/images/typeImages/tiktok-icon.png",
    ttmessaging: "/assets/images/typeImages/tiktok-icon.png",
    scpixel: "/assets/images/typeImages/snapchat-icon.png",
    sccapi: "/assets/images/typeImages/snapchat-icon.png",
    pnpixel: "/assets/images/typeImages/pinterest-icon.png",
    pncapi: "/assets/images/typeImages/pinterest-icon.png",
    ggads: "/assets/images/typeImages/google-ads-icon.png",
    ggads_web: "/assets/images/typeImages/google-ads-icon.png",
    ggawc: "/assets/images/typeImages/google-ads-icon.png",
    ggaoc: "/assets/images/typeImages/google-ads-icon.png",
    ggalc: "/assets/images/typeImages/google-ads-icon.png",
    ggass: "/assets/images/typeImages/google-ads-icon.png",
    ggads4: "/assets/images/typeImages/google-ads.png",
    twcapi: "/assets/images/typeImages/tw-icon.png",
    twpixel: "/assets/images/typeImages/tw-icon.png",
    rdcapi: "/assets/images/typeImages/reddit-capi.png",
    rdpixel: "/assets/images/typeImages/reddit-capi.png",
    imcapi: "/assets/images/typeImages/impact.png",
    sstask: "/assets/images/typeImages/sstask.png",
    ggbq: "/assets/images/typeImages/bigquery.png",
    licapi: "/assets/images/typeImages/lead/sources/linkedin.png",
    msoffline: "/assets/images/typeImages/bing.png",
    ymwc: "/assets/images/yandex.png",
    lnpixel: "/assets/images/typeImages/line.png",
    lncapi: "/assets/images/typeImages/line.png",
    oaipixel: "/assets/images/openai.webp",
    oaicapi: "/assets/images/openai.webp",
};

/** Same wordmark the sidebar uses. Shown for destination types we have no icon for. */
export const SIGNALSIGHT_LOGO = "/assets/images/signal-sight.png";

export const getDestinationIconByCode = (code) =>
    DESTINATION_ICON_BY_CODE[code] ?? SIGNALSIGHT_LOGO;

export const getDestinationIcon = (destinations, destinationTypeId) => {
    const destination = destinations?.find(
        (item) => item.destination_type_id === destinationTypeId,
    );

    return getDestinationIconByCode(destination?.destination_type?.code);
};

export default getDestinationIconByCode;
